import styled, { css } from 'styled-components'
import { designTokens } from '../Theme/designTokens'
import { Link } from 'gatsby'

const base = css`
  display: ${(props) => props.block ? 'block' : 'inline-flex'};
  width: ${(props) => props.block ? '100%' : 'auto'};
  align-items: center;
  cursor: pointer;
  padding: calc(${designTokens.space[1]} + ${designTokens.space[2]}) ${designTokens.space[3]};
  border: 0;
  font-size: ${(props) => props.size === 'lg' ? designTokens.fontSizes[2] : designTokens.fontSizes[1]};
  border-radius: ${designTokens.space[2]};
  background: ${(props) => props.bg ? props.bg : ({ theme }) => theme.grey200};
  color: ${(props) => props.color ? props.color : ({ theme }) => theme.grey900};
  margin-top: ${(props) => props.marginTop ? props.marginTop : '0'};
  margin-bottom: ${(props) => props.marginBottom ? props.marginBottom : '0'};
  margin-left: ${(props) => props.marginLeft ? props.marginLeft : '0'};
  margin-right: ${(props) => props.marginRight ? props.marginRight : '0'};
  position: relative;
  text-align: center;
  transition: all 120ms ease-out 0s;
  &:hover,&:focus {
    opacity: .75;
  }
`;

const ghostBase = css`
  background: transparent;
  text-shadow: 0px 0px 4px ${({ theme }) => theme.grey0};
  margin-top: ${(props) => props.marginTop ? props.marginTop : '0'};
  margin-bottom: ${(props) => props.marginBottom ? props.marginBottom : '0'};
  margin-left: ${(props) => props.marginLeft ? props.marginLeft : '0'};
  margin-right: ${(props) => props.marginRight ? props.marginRight : '0'};
  &:after {
    content: '';
    border-radius: ${designTokens.space[2]};
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: currentColor;
    opacity: 0.12;
  }
`;

export const Button = styled.button`
  ${base}
`;

export const ButtonGhost = styled(Button)`
  ${ghostBase}
`;

export const ButtonLink = styled(Link)`
  ${base}
`;

export const ButtonLinkGhost = styled(ButtonLink)`
  ${ghostBase}
`;

export const ButtonOutbound = styled.a`
  ${base}
`;

export const ButtonOutboundGhost = styled(ButtonOutbound)`
  ${ghostBase}
`;